// extracted by mini-css-extract-plugin
var _1 = "MoreItem-moduleicon__hzzHj FileIcon-moduleFileIcon__sDjTw IconNG-moduleiconContainer__SxWZ0";
var _2 = "MoreItem-moduleitem__xFK5p";
var _3 = "MoreItem-modulemoreItem__vi2yu MultiValuedListMoreItem-moduleMultiValuedListMoreItem__SSTEE";
var _4 = "MoreItem-moduletext__DYeuI";
export { _1 as "icon", _2 as "item", _3 as "moreItem", _4 as "text" }
